import firebase from "firebase/app";
import "firebase/auth";

export const auth = firebase.initializeApp({
  apiKey: "AIzaSyAyAQgyrVG-xvkiX7k43ejVNJiYcm-o-Es",
  authDomain: "tchat-93d5b.firebaseapp.com",
  projectId: "tchat-93d5b",
  storageBucket: "tchat-93d5b.appspot.com",
  messagingSenderId: "503916557252",
  appId: "1:503916557252:web:b417435431a19d94d06a91"
}).auth();